module.exports = __webpack_public_path__ + "img/bg_avatar_female_89.3427b87c.png";